import React from 'react';
import {
  RadioGroup,
  IllustratedRadioButton,
  Grid,
  Text,
  IllustrationRounded,
} from '@wegroup/design-system';
import AdaptiveText from 'react-adaptive-text';
import { FlowsQuestion } from '../../../../flows/src/types/FlowsTypes';
import useFlowInputComponent from '../../../../flows/src/hooks/useFlowsInputComponent';
import useQuestionEnum from '../../../../flows/src/hooks/useQuestionEnum';
import useMobileBreakpoints from '../../../../common/src/hooks/useMobileBreakpoints';

interface Props {
  question: FlowsQuestion;
}

const SelectDetailedInputComponent: React.FC<
  React.PropsWithChildren<Props>
> = ({ question }) => {
  const {
    field: { value, onBlur },
    error,
  } = useFlowInputComponent({ question });

  const options = useQuestionEnum(question);
  const { isTabletS } = useMobileBreakpoints();

  const isOneRow = options.length < 4;

  return (
    <RadioGroup
      onChange={(val: string) => onBlur({ name: question.id, value: val })}
      value={value}
      w="100%"
    >
      <Grid
        w="100%"
        justifyContent="center"
        templateColumns={{
          base: 'repeat(2, 1fr)',
          tabletS: `repeat(${
            isOneRow ? options.length : 'auto-fill'
          }, minmax(120px, 210px))`,
        }}
        gridGap={{ base: '2', tabletS: '4', tablet: '6' }}
      >
        {/* ErrorText */}
        {error && (
          <Text textAlign="center" color="danger.main" gridColumn="1/-1">
            {error.message}
          </Text>
        )}

        {/* Options */}
        {options.map(
          ({
            label,
            value: _value,
            icon_key,
            description,
            disabled_description,
            disabled,
          }) => (
            <IllustratedRadioButton
              description={disabled ? disabled_description : description}
              disabled={disabled}
              Illustration={
                <IllustrationRounded
                  type={
                    icon_key ||
                    `${question.id.split('.')[1]?.toUpperCase()}_${_value}`
                  }
                  isActive={_value === value}
                />
              }
              key={label + _value}
              value={_value as string}
            >
              <AdaptiveText
                fontFamily="Circular"
                text={label}
                fontSizeMin={isTabletS ? 14 : 12}
                fontSizeMax={isTabletS ? 20 : 18}
              />
            </IllustratedRadioButton>
          ),
        )}
      </Grid>
    </RadioGroup>
  );
};

export default SelectDetailedInputComponent;
